module.exports = __webpack_public_path__ + "img/mine.b55c6823.png";